<template>
    <div class="search-page">
        <Header pageTitle="البحث" />

        <div class="search-container">
            <router-link to="/home" class="btn mb-3" style="background-color: #b1cedf; color: #000;width: 100%;">
                عودة للصفحة الرئيسية
            </router-link>
            <div class="search-bar">
                <input type="text" v-model="searchQuery" placeholder="ابحث عن منشورات أو متخصصين..." />
                <div class="search-options">
                    <button :class="{ active: searchType === '1' }" @click="searchType = '1'">المنشورات</button>
                    <button :class="{ active: searchType === '2' }" @click="searchType = '2'">المتخصصون</button>
                </div>
            </div>

            <div v-if="loading" class="loading">جاري البحث...</div>
            <div class="cardSearchs">
                <div v-if="searchResults.length > 0" class="results ">
                    <div v-if="searchType === '1'">
                        <div class="col-md-6 cards-container">
                            <div v-for="post in posts" :key="post.posts_id">
                                <PostCard :post="post" />
                            </div>
                        </div>
                    </div>
                    <div v-else>
                        <div class="col-md-6 cards-container">
                            <FreelancerCard v-for="freelancer in freelancers" :key="freelancer.profiles_id"
                                :freelancer="freelancer" />
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="searchResults.length === 0 && !loading" class="no-results">
                لا توجد نتائج للبحث.
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import Header from "../../components/header.vue";
import PostCard from "../../components/PostCard.vue";
import FreelancerCard from "../../components/FreelancerCard.vue";

export default {
    name: "SearchPage",
    components: {
        PostCard,
        Header,
        FreelancerCard,
    },
    data() {
        return {
            searchQuery: "",
            searchType: "1", // القيمة الافتراضية هي البحث عن المنشورات
            searchResults: [],
            freelancers: [], // مصفوفة لحفظ نتائج المتخصصين
            posts: [], // مصفوفة لحفظ نتائج المنشورات
            loading: false,
        };
    },
    watch: {
        // مراقبة تغييرات searchQuery وتنفيذ البحث تلقائيًا
        searchQuery(newQuery) {
            if (newQuery.trim() !== "") {
                this.performSearch();
            } else {
                this.searchResults = [];
                this.posts = [];
                this.freelancers = [];
            }
        },
        // مراقبة تغييرات searchType وتنفيذ البحث تلقائيًا
        searchType() {
            if (this.searchQuery.trim() !== "") {
                this.performSearch();
            }
        },
    },
    methods: {
        async performSearch() {
            this.loading = true;
            this.searchResults = [];

            try {
                const response = await axios.post(
                    "https://zadcodeonline.com/ahmad/etqan/backEnd/search/search.php",
                    {
                        search: this.searchQuery,
                        searchtype: this.searchType,
                    },
                    {
                        headers: { "Content-Type": "multipart/form-data" },
                    }
                );

                if (response.data.status === "success") {
                    this.searchResults = response.data.data;

                    // حفظ النتائج في المصفوفة المناسبة بناءً على نوع البحث
                    if (this.searchType === "1") {
                        this.posts = response.data.data; // حفظ نتائج المنشورات
                    } else if (this.searchType === "2") {
                        this.freelancers = response.data.data; // حفظ نتائج المتخصصين
                    }
                } else {
                    console.error("فشل في البحث:", response.data.message);
                }
            } catch (error) {
                console.error("خطأ أثناء البحث:", error);
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>

<style scoped>
.cardSearchs {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.search-page {
    direction: rtl;
    padding-top: 70px;
}

.search-container {
    padding: 20px;
}

.search-bar {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-bottom: 20px;
}

.search-bar input {
    flex: 1;
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 15px;
    font-size: 16px;
}

.search-options {
    display: flex;
    justify-content: space-between;
    gap: 10px;
}

.search-options button {
    padding: 15px 30px;
    background-color: #e1e8ed;
    border: none;
    border-radius: 15px;
    cursor: pointer;
    font-size: 16px;
    transition: background-color 0.3s ease;
}

.search-options button.active {
    background-color: #296080;
    color: white;
}

.search-options button:hover {
    background-color: #003a5c;
    color: white;
}

.loading {
    text-align: center;
    font-size: 18px;
    margin-top: 20px;
}

.results {
    margin-top: 20px;
}

.no-results {
    text-align: center;
    font-size: 18px;
    margin-top: 20px;
    color: #888;
}


@media (min-width: 992px) {
    .search-page {
        padding: 70px 50px 0 50px;
    }
}

@media (min-width: 1200px) {
    .search-page {
        padding: 70px 100px 0 100px;
    }
}
</style>